<template>
  <div>
    <v-row>
      <v-col>
        <v-tabs
          v-model="userTab"
          show-arrows
          class="user-tabs"
        >
          <v-tab
            v-for="tab in tabs"
            :key="tab.icon"
            @click="getdepartamento"
          >
            <v-icon
              size="20"
              class="me-3"
            >
              {{ tab.icon }}
            </v-icon>
            <span>{{ tab.title }}</span>
          </v-tab>

          <v-tab
            :to="{ name: 'departamentos' }"
          >
            <v-icon
              color="error"
            >
              {{ icons.mdiCloseCircleOutline }}
            </v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items
          id="user-tabs-content"
          v-model="userTab"
          class="mt-5 "
        >
          <v-tab-item>
            <div style="min-height: 4px">
              <v-progress-linear
                v-if="loading"
                indeterminate
              ></v-progress-linear>
            </div>
            <departamento-tab-connections
              :key="departamento.id"
              :acesso-put="acessoPut"
              :connections-data="departamento"
              @atualizarDepartamento="getdepartamento"
            >
            </departamento-tab-connections>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiBookmarkOutline, mdiCloseCircleOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { mapState } from 'pinia'
import router from '@/router'
import DepartamentoTabConnections from '@/views/departamento/DepartamentoTabConnections.vue'
import useAuthStore from '@/store/auth'
import DepartamentoService from '@/services/modules/DepartamentoService'

export default {
  components: {
    DepartamentoTabConnections,
  },

  data() {
    return {
      departamento: {},
      loading: false,
      idPut: 1013,
      acessoPut: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    this.getdepartamento()
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPut)) {
        this.acessoPut = false
      }
    },

    async getdepartamento() {
      this.loading = true

      try {
        this.departamento = await DepartamentoService.getById(router.currentRoute.params.id)

        setTimeout(() => {
          this.loading = false
        }, 1000)
      } catch {
        this.loading = false
      }
    },
  },

  setup() {
    const userData = ref({})
    const userTab = ref('')

    const tabs = [
      { icon: mdiBookmarkOutline, title: 'DEPARTAMENTO' },
    ]

    return {
      tabs,
      userTab,
      userData,
      icons: {
        mdiCloseCircleOutline,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
